export const DataHooks = {
  Root: 'Button.Root',
  ProgressIndicator: 'Button.ProgressIndicator',
} as const;
